import { JxsComponent } from '@jxs/component';

class JxsStickyTabContentReview extends JxsComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    document.querySelector('.jdgm-preview-badge')?.addEventListener('click', this.#handleReviewBadgeClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.querySelector('.jdgm-preview-badge')?.removeEventListener('click', this.#handleReviewBadgeClick);
  }

  #handleReviewBadgeClick = () => {
    const item = this.closest('.jxs-block-sticky-tab-item');
    if (item) {
      this.closest('jxs-sticky-tab-content')?.active(item.id);
    }
  }
}
customElements.define('jxs-sticky-tab-content-review', JxsStickyTabContentReview);

class JxsStickyTabContent extends JxsComponent {

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.init();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  async init() {
    const items = [];
    this.refs.items?.forEach(item => {
      if (item.children.length > 0) {
        const tabItem = document.createElement('div');
        tabItem.textContent = item.dataset.title;
        tabItem.dataset.contentId = item.id;
        tabItem.classList.add('jxs-sticky-tab-content__head');
        tabItem.addEventListener('click', this.#handleTabItemClick);
        items.push(tabItem);
      }
    });
    const autoScrollLayout = this.refs.tabbar.querySelector('jxs-auto-scroll-layout');
    await customElements.whenDefined('jxs-auto-scroll-layout');
    autoScrollLayout.init(items);
    if (items.length > 0) {
      items[0].click();
    }
  }

  #handleTabItemClick = (e) => {
    this.refs.tabbar.querySelectorAll('.jxs-sticky-tab-content__head').forEach(item => {
      item.removeAttribute('active');
    });
    const contentId = e.target.dataset.contentId;
    e.target.setAttribute('active', '');
    this.refs.items.forEach(item => {
      item.removeAttribute('active');
      if (contentId == item.id) {
        item.setAttribute('active', '');
      }
    })
  }

  active(id) {
    this.refs.tabbar.querySelector(`.jxs-sticky-tab-content__head[data-content-id="${id}"]`)?.click();
  }
}
customElements.define('jxs-sticky-tab-content', JxsStickyTabContent);